export default [
  {
    category: "Frontend",
    name: "My Routine ",
    description:
      "My Routine App is Todolist and Promodoro Timer app which used to create todolist based on priority of task and to keep focus during work which contain functionality of edit,delete task.",
    technology: ["react", "javascript", "redux", "html", "css", "chakra"],
    github: "https://github.com/richhapal/My-Routine",
    live: "https://todolist-richhapal.netlify.app/",
    img: "myroutine",
  },
  {
    category: "Frontend",
    name: "Weather App",
    description:
      "Weather project show your search city weather based on Frontend Development which show city's current weather details,7-day forecast and daily 24-Hour weather cast. ",
    technology: ["react", "javascript", "redux", "html", "css", "sass"],
    github: "https://github.com/richhapal/WEATHER-APP",
    live: "https://weather-richhapal.netlify.app/",
    img: "weather",
  },
  {
    category: "Frontend",
    name: "My Portfolio",
    description:
      "My personal portfolio contain my visual representation of my skills,projects and technical skills such programming languages,frameworks and other social profiles.",
    technology: ["react", "javascript", "redux", "html", "css", "sass"],
    github: "https://github.com/richhapal/my-personal-portfolio",
    live: "https://richhapal.netlify.app/",
    img: "portfolio",
  },
];
// {
//      category: "Frontend",
//      name: "Qtrip",
//      description:
//           "QTrip is a travel website aimed at travellers looking for a multitude of adventures in different cities.City's Adventure can be filter by duration and categories. ",
//      technology: ["javascript", "html", "css", "bootstrap"],
//      github: "https://github.com/richhapal/qtrip-richhapal",
//      live: "https://qtriprichhapal.netlify.app/",
//      img: "qtrip",
// },

// {
//      category: "Frontend",
//      name: "Ekart",
//      description:
//        "Ekart is an online e-commerce webiste. Ekart project is mainly focus on Frontend Development which contain Login,Register,Cart,Search-Item and filter functionality.",
//      technology: ["react", "javascript", "html", "css", "material"],
//      github: "https://github.com/richhapal/Ekart-Frontend",
//      live: "https://qkart-richhapal.netlify.app/",
//      img: "qkart",
//    },
